<div class="filter-trigger">
  <p-button
    [label]="'SETTINGS.PUSH_NOTIFICATIONS.FILTER.FILTERS' | translate"
    icon="pi pi-filter"
    [severity]="hasActiveFilters() ? 'primary' : 'secondary'"
    [attr.aria-label]="'SETTINGS.PUSH_NOTIFICATIONS.FILTER.FILTERS' | translate"
    (onClick)="toggleFilterPopover($event)" />

  @if (hasActiveFilters()) {
    <p-button
      [label]="'SETTINGS.PUSH_NOTIFICATIONS.FILTER.CLEAR_FILTERS' | translate"
      icon="pi pi-filter-slash"
      severity="secondary"
      (onClick)="clearFilters()" />
  }
</div>

<p-popover #filterPopover styleClass="push-device-filter-popover" [focusOnShow]="false">
  <div class="filter-content">
    <div class="filter-section">
      <div class="filter-field">
        <label for="push-platform-type">
          {{ 'SETTINGS.PUSH_NOTIFICATIONS.FILTER.PLATFORM_TYPE' | translate }}
        </label>
        <p-select
          inputId="push-platform-type"
          [ngModel]="localPlatformType()"
          (ngModelChange)="onPlatformTypeChange($event)"
          [options]="platformOptions"
          optionLabel="label"
          optionValue="value"
          [placeholder]="'SETTINGS.PUSH_NOTIFICATIONS.FILTER.PLATFORM_TYPE_ALL' | translate"
          [showClear]="true"
          styleClass="filter-input">
          <ng-template let-option pTemplate="item">{{ option.label | translate }}</ng-template>
          <ng-template let-option pTemplate="selectedItem">{{ option.label | translate }}</ng-template>
        </p-select>
      </div>
    </div>

    <div class="filter-actions">
      <p-button
        [label]="'GENERAL.APPLY' | translate"
        severity="primary"
        styleClass="w-full"
        [disabled]="isLoading()"
        (onClick)="applyFilters()" />
      <p-button
        [label]="'GENERAL.CLEAR' | translate"
        severity="secondary"
        styleClass="w-full"
        [disabled]="!hasActiveFilters() || isLoading()"
        (onClick)="clearFilters()" />
    </div>
  </div>
</p-popover>
